const en_mitra = {
    "": "SCM online partner",
    btn_request: "partnership request",
    connect_to: "connected to",

    label: {
        connect_text: "already connected to"
    },

    menu: {
        confirmation: "partner request confirmation",
        product: "partner product list",
        product_own: "shared product list",
        search: "search partner",
    },

}

export default en_mitra;